import React, { useState, useMemo } from 'react';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { toKey } from '@tmap/mmm-core/entityKey';
import useLazySSR from '@tmap/mmm-style-guide/src/ssr/useLazySSR';
import useCurrentUser from '../../hooks/useCurrentUser';
import ColorBlocks from '../../layouts/colorBlocks';
import { getRandomEntry } from '../../lib/helpers';
import WhereYouLiveQuestion from './whereYouLiveQuestion';
import useUserListItem from '../../hooks/useUserListItem';

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  textTransform: 'uppercase',
  color: theme.palette.secondary.light,
  marginBottom: '20px',
}));

function SurveyQuestionBlock({ community }) {
  const user = useCurrentUser();
  const entityKey = toKey(community._type, community._id);
  const userFavorite = useUserListItem({ entityKey });

  const [answered, setAnswered] = useState(false);
  const questions = useMemo(() => {
    const qs = [];
    const isFavorite = (!!userFavorite && userFavorite?.status === 'active');

    // Just one question for now.
    // In the future we may expand these by conditionally pushing additional options
    if (
      Object.keys(user).length
      && !isFavorite
      && (!user.personalInfo?.state || !user.personalInfo?.city)
    ) {
      qs.push(WhereYouLiveQuestion);
    }

    return qs;
  }, [user, userFavorite]);

  // Don't show a question in SSR
  const Question = useLazySSR((ssr) => (
    ssr
      ? null
      : getRandomEntry(questions)
  ), [questions]);
  if (!Question || (!answered && questions.length === 0)) {
    return null;
  }
  return (
    <ColorBlocks.Block color='primaryDark' marginTop={6}>
      {answered ? <Typography color='textPrimary' sx={{ fontWeight: 600 }}>Thank you!</Typography> : (
        <>
          <Title>We&apos;d Love Your Input</Title>
          <Question
            community={community}
            setAnswered={setAnswered}
          />
        </>
      )}
    </ColorBlocks.Block>
  );
}

export default SurveyQuestionBlock;
